












































































































































































































import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { checkPermissions } from '@/directives/permissionDirective'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import { Filter } from '@/interfaces/filter.interface'
import { APIPagination } from '@/models/api/pagination.model'
import moment from 'moment'
import { Component, Vue, Watch } from 'vue-property-decorator'
import StatementForm from './StatementForm.vue'
import StatementList from './StatementList.vue'
import StatementNotificationModal from './StatementNotificationModal.vue'
import StatementNotificationTemplateModal from './StatementNotificationTemplateModal.vue'

@Component({
    components: {
        ConfirmDialog,
        StatementForm,
        StatementList,
        StatementNotificationModal,
        StatementNotificationTemplateModal
    }
})
export default class Statement extends Vue {
    loading = false
    mainTitle = 'Statements'
    filters: Filter[] = []
    dateFilter: string[][] = []
    filterList: Filter[] = []

    selectedRows = []
    selectRows = false
    data: object[] = []
    rowsPerPage = 15
    permissionPrefix = 'statement'

    sortBy = ''
    sortByDesc = false

    pagination: APIPagination = {
        currentPage: 1,
        total: 0,
        nextPage: null,
        previousPage: null
    }

    uploadFromFile = {
        active: false,
        mode: 'Add',
        valid: false,
        uploadfile: null,
        statementDate: '',
        providerId: null
    }

    chipFile = false

    customColums: ADMColumn[] = []
    columns: ADMColumn[] = [
        {
            text: 'Date',
            value: 'statementDate',
            customField: {
                type: 'dateOnly'
            }
        },
        {
            text: 'Carrier',
            value: 'providerId.carrierId.carrierName',
            sortable: false
        },
        {
            text: 'Provider',
            value: 'providerId.providerName',
            sortable: false
        },
        {
            text: 'Actions',
            width: '100px',
            customField: {
                type: 'options',
                hideAll: false
            }
        }
    ]

    statementEdit ={}

    notificationManagerOpen = false
    templateManagerOpen = false
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notificationStatement: any = null

    @Watch('filters')
    onFiltersChange () {
        if (this.filters.length === 0) this.filterHandler()
    }

    // METHODS

    checkPermision (permission: string) {
        return !!checkPermissions(permission)
    }

    addFilter () {
        this.filters.push(JSON.parse(JSON.stringify(this.filterList[0])))
        this.dateFilter.push([])
    }

    removeFilter (filterIndex: number) {
        this.filters = this.filters.filter((filter, index) => index !== filterIndex)
        this.dateFilter = this.dateFilter.filter((filter, index) => index !== filterIndex)
        this.$forceUpdate()
    }

    updateFilter (index: number, newFilter: string) {
        const foundFilter = this.filterList.find(filter => filter.value === newFilter)
        if (foundFilter) this.filters[index] = JSON.parse(JSON.stringify(foundFilter))
        this.$forceUpdate()
    }

    newLimitHandler (val: number) {
        this.rowsPerPage = val
        this.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    paginationTable (val: number) {
        this.pagination.currentPage = val
        this.loadData()
    }

    getMonthNow () {
        return moment().format('YYYY-MM').toString()
    }

    filterHandler () {
        this.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    closeModal () {
        this.statementEdit = {}
        this.uploadFromFile.active = false
    }

    createField () {
        this.statementEdit = {}
        this.uploadFromFile.active = true
        this.uploadFromFile.mode = 'Add'
        this.uploadFromFile.uploadfile = null
        this.uploadFromFile.statementDate = ''
        this.uploadFromFile.providerId = null
        this.chipFile = false
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editField (field: any) {
        this.statementEdit = field
        this.uploadFromFile.active = true
        this.uploadFromFile.mode = 'Edit'
        this.uploadFromFile.uploadfile = null
        this.chipFile = true
    }

    getProviders () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorProvidersFilter', { carrierId: this.userData.carrierId?.carrierId })
                .then(resp => {
                    if (resp.status === 200) {
                        resp.data.forEach((provider: {providerId: number; providerName: string}) => {
                            if (this.filterList[0]?.values) {
                                this.filterList[0].values.push({
                                    text: provider.providerName,
                                    value: provider.providerId
                                })
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getCarriers () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorCarriersFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        resp.data.forEach((carrier: {carrierId: number; carrierName: string}) => {
                            if (this.filterList[1]?.values) {
                                this.filterList[1].values.push({
                                    text: carrier.carrierName,
                                    value: carrier.carrierId
                                })
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    loadStatementList (sort?: { sortBy: string; sortByDesc: boolean }) {
        // The list emits 'loadData' without payload on a plain refresh (e.g. after
        // a delete), and with the sort state when the user changes the ordering.
        if (sort) {
            this.sortBy = sort.sortBy
            this.sortByDesc = sort.sortByDesc
        }
        this.loadData()
    }

    loadData () {
        this.loading = true
        this.filters.forEach((filter, i) => {
            if (filter.type === 'date') {
                filter.queryValue = this.dateFilter[i]
            }
        })
        const providerId = this.userData.providerId?.providerId
        const carrierId = this.userData.carrierId?.carrierId

        this.$store.dispatch('getStatementsPaginate', {
            page: this.pagination.currentPage,
            filters: this.filters,
            limit: this.rowsPerPage,
            providerId,
            carrierId,
            sortBy: this.sortBy,
            sort: this.sortByDesc ? 'asc' : 'desc'
        })
            .then(resp => {
                if (resp?.status === 200) {
                    this.pagination = { ...this.$store.state.StatementStore.statementsPaginate }
                    this.data = this.$store.state.StatementStore.statementsPaginate.results || []
                    if (this.pagination.results) delete this.pagination.results

                    if (!this.pagination?.currentPage) this.pagination.currentPage = 1

                    this.loading = false
                }
            })
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    getFilters () {
        if (!this.userData.providerId) {
            this.filterList.push({
                text: 'Provider',
                type: 'select',
                value: 'providerId',
                queryValue: '',
                values: []
            })
        }
        if (!this.userData.carrierId) {
            this.filterList.push({
                text: 'Carrier',
                type: 'select',
                value: 'carrierId',
                queryValue: '',
                values: []
            })
        }
        this.filterList.push({
            text: 'Date',
            type: 'date',
            value: 'statementDate',
            queryValue: ''
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    openNotification (statement: any) {
        this.notificationStatement = statement
        this.$nextTick(() => {
            this.notificationManagerOpen = true
        })
    }

    openTemplateManager () {
        this.templateManagerOpen = true
    }

    async mounted () {
        this.columns.forEach(column => {
            if (column.customField) this.customColums.push(column)
        })
        this.getFilters()
        this.loadData()
        await this.getProviders()
        await this.getCarriers()
    }
}
